import * as THREE from "three";

/**
 * A small floating indicator over Bubble Sort's current comparison pair
 * (Master Spec §25) so the player knows where to walk next — mirrors
 * MidMarker.ts's role for Binary Search's pivot, in its own color so the
 * two stages read as visually distinct at a glance.
 */
export interface ComparePointerHandles {
  mesh: THREE.Mesh;
  setVisible: (visible: boolean) => void;
  dispose: () => void;
}

const MARKER_COLOR = 0xf4c542;
const MARKER_EMISSIVE = 0x4a3a08;

export function createComparePointer(): ComparePointerHandles {
  const geometry = new THREE.ConeGeometry(0.18, 0.32, 4);
  const material = new THREE.MeshStandardMaterial({
    color: MARKER_COLOR,
    roughness: 0.3,
    emissive: MARKER_EMISSIVE,
    emissiveIntensity: 0.6,
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.x = Math.PI;
  mesh.visible = false;

  function setVisible(visible: boolean): void {
    mesh.visible = visible;
  }

  function dispose(): void {
    geometry.dispose();
    material.dispose();
  }

  return { mesh, setVisible, dispose };
}
